import { MouseSelectionStates } from "types";

import { getGroupName, getSeriesName } from "./utils";

export function materialBalanceTimeHoverLegends({
  params,
  series,
  forecast
}: Partial<MouseSelectionStates>) {
  const seriesName = getSeriesName({ params, series, forecast });
  const groupName = getGroupName({ params, series });

  return {
    hoverLegendItem: seriesName,
    hoverLegendGroup: groupName
  };
}
